/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetVoiceMessageByIdDto } from '../models/custom-result-of-get-voice-message-by-id-dto';
import { CustomResultOfListOfGetVoiceMessagesListDto } from '../models/custom-result-of-list-of-get-voice-messages-list-dto';
import { CustomResultOfListOfGetVoicesByVoiceMessageGroupDto } from '../models/custom-result-of-list-of-get-voices-by-voice-message-group-dto';
import { CustomResultOfPaginatedListOfGetVoiceMessagesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-voice-messages-with-pagination-dto';
import { CustomResultOfUploadVocalistResult } from '../models/custom-result-of-upload-vocalist-result';
import { voiceMessagesCreateVoiceMessageByVocalist } from '../fn/voice-messages/voice-messages-create-voice-message-by-vocalist';
import { VoiceMessagesCreateVoiceMessageByVocalist$Params } from '../fn/voice-messages/voice-messages-create-voice-message-by-vocalist';
import { voiceMessagesDeleteDelete } from '../fn/voice-messages/voice-messages-delete-delete';
import { VoiceMessagesDeleteDelete$Params } from '../fn/voice-messages/voice-messages-delete-delete';
import { voiceMessagesDeleteGet } from '../fn/voice-messages/voice-messages-delete-get';
import { VoiceMessagesDeleteGet$Params } from '../fn/voice-messages/voice-messages-delete-get';
import { voiceMessagesDeleteVoiceMessagesByIdsDelete } from '../fn/voice-messages/voice-messages-delete-voice-messages-by-ids-delete';
import { VoiceMessagesDeleteVoiceMessagesByIdsDelete$Params } from '../fn/voice-messages/voice-messages-delete-voice-messages-by-ids-delete';
import { voiceMessagesDeleteVoiceMessagesByIdsGet } from '../fn/voice-messages/voice-messages-delete-voice-messages-by-ids-get';
import { VoiceMessagesDeleteVoiceMessagesByIdsGet$Params } from '../fn/voice-messages/voice-messages-delete-voice-messages-by-ids-get';
import { voiceMessagesGetNewStatusGet } from '../fn/voice-messages/voice-messages-get-new-status-get';
import { VoiceMessagesGetNewStatusGet$Params } from '../fn/voice-messages/voice-messages-get-new-status-get';
import { voiceMessagesGetNewStatusPost } from '../fn/voice-messages/voice-messages-get-new-status-post';
import { VoiceMessagesGetNewStatusPost$Params } from '../fn/voice-messages/voice-messages-get-new-status-post';
import { voiceMessagesGetVoiceMessageAuditWithPagination } from '../fn/voice-messages/voice-messages-get-voice-message-audit-with-pagination';
import { VoiceMessagesGetVoiceMessageAuditWithPagination$Params } from '../fn/voice-messages/voice-messages-get-voice-message-audit-with-pagination';
import { voiceMessagesGetVoiceMessagesList } from '../fn/voice-messages/voice-messages-get-voice-messages-list';
import { VoiceMessagesGetVoiceMessagesList$Params } from '../fn/voice-messages/voice-messages-get-voice-messages-list';
import { voiceMessagesGetVoiceMessageWithPagination } from '../fn/voice-messages/voice-messages-get-voice-message-with-pagination';
import { VoiceMessagesGetVoiceMessageWithPagination$Params } from '../fn/voice-messages/voice-messages-get-voice-message-with-pagination';
import { voiceMessagesGetVoicesByVoiceMessageGroup } from '../fn/voice-messages/voice-messages-get-voices-by-voice-message-group';
import { VoiceMessagesGetVoicesByVoiceMessageGroup$Params } from '../fn/voice-messages/voice-messages-get-voices-by-voice-message-group';
import { voiceMessagesUpdateStatusGet } from '../fn/voice-messages/voice-messages-update-status-get';
import { VoiceMessagesUpdateStatusGet$Params } from '../fn/voice-messages/voice-messages-update-status-get';
import { voiceMessagesUpdateStatusPost } from '../fn/voice-messages/voice-messages-update-status-post';
import { VoiceMessagesUpdateStatusPost$Params } from '../fn/voice-messages/voice-messages-update-status-post';
import { voiceMessagesUpdateUploadedFileGet } from '../fn/voice-messages/voice-messages-update-uploaded-file-get';
import { VoiceMessagesUpdateUploadedFileGet$Params } from '../fn/voice-messages/voice-messages-update-uploaded-file-get';
import { voiceMessagesUpdateUploadedFilePost } from '../fn/voice-messages/voice-messages-update-uploaded-file-post';
import { VoiceMessagesUpdateUploadedFilePost$Params } from '../fn/voice-messages/voice-messages-update-uploaded-file-post';
import { voiceMessagesUpdateVoiceMessageGroup } from '../fn/voice-messages/voice-messages-update-voice-message-group';
import { VoiceMessagesUpdateVoiceMessageGroup$Params } from '../fn/voice-messages/voice-messages-update-voice-message-group';
import { voiceMessagesUploadFileGet } from '../fn/voice-messages/voice-messages-upload-file-get';
import { VoiceMessagesUploadFileGet$Params } from '../fn/voice-messages/voice-messages-upload-file-get';
import { voiceMessagesUploadFilePost } from '../fn/voice-messages/voice-messages-upload-file-post';
import { VoiceMessagesUploadFilePost$Params } from '../fn/voice-messages/voice-messages-upload-file-post';
import { voiceMessagesUploadVocalistFile } from '../fn/voice-messages/voice-messages-upload-vocalist-file';
import { VoiceMessagesUploadVocalistFile$Params } from '../fn/voice-messages/voice-messages-upload-vocalist-file';

@Injectable({ providedIn: 'root' })
export class VoiceMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `voiceMessagesUploadFileGet()` */
  static readonly VoiceMessagesUploadFileGetPath = '/VoiceMessages/UploadFile';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUploadFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUploadFileGet$Response(params?: VoiceMessagesUploadFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return voiceMessagesUploadFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUploadFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUploadFileGet(params?: VoiceMessagesUploadFileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.voiceMessagesUploadFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUploadFilePost()` */
  static readonly VoiceMessagesUploadFilePostPath = '/VoiceMessages/UploadFile';

  /**
   * آپلود فایل جدید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUploadFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  voiceMessagesUploadFilePost$Response(params?: VoiceMessagesUploadFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesUploadFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود فایل جدید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUploadFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  voiceMessagesUploadFilePost(params?: VoiceMessagesUploadFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesUploadFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUpdateUploadedFileGet()` */
  static readonly VoiceMessagesUpdateUploadedFileGetPath = '/VoiceMessages/UpdateUploadedFile';

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUpdateUploadedFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUpdateUploadedFileGet$Response(params?: VoiceMessagesUpdateUploadedFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetVoiceMessageByIdDto>> {
    return voiceMessagesUpdateUploadedFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUpdateUploadedFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUpdateUploadedFileGet(params?: VoiceMessagesUpdateUploadedFileGet$Params, context?: HttpContext): Observable<CustomResultOfGetVoiceMessageByIdDto> {
    return this.voiceMessagesUpdateUploadedFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetVoiceMessageByIdDto>): CustomResultOfGetVoiceMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUpdateUploadedFilePost()` */
  static readonly VoiceMessagesUpdateUploadedFilePostPath = '/VoiceMessages/UpdateUploadedFile';

  /**
   * آپدیت فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUpdateUploadedFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  voiceMessagesUpdateUploadedFilePost$Response(params?: VoiceMessagesUpdateUploadedFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesUpdateUploadedFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * آپدیت فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUpdateUploadedFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  voiceMessagesUpdateUploadedFilePost(params?: VoiceMessagesUpdateUploadedFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesUpdateUploadedFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUpdateStatusGet()` */
  static readonly VoiceMessagesUpdateStatusGetPath = '/VoiceMessages/UpdateStatus';

  /**
   * بررسی دسترسی آپدیت وضعیت فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUpdateStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUpdateStatusGet$Response(params?: VoiceMessagesUpdateStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return voiceMessagesUpdateStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی آپدیت وضعیت فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUpdateStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesUpdateStatusGet(params?: VoiceMessagesUpdateStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.voiceMessagesUpdateStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUpdateStatusPost()` */
  static readonly VoiceMessagesUpdateStatusPostPath = '/VoiceMessages/UpdateStatus';

  /**
   * آپدیت وضعیت فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUpdateStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUpdateStatusPost$Response(params: VoiceMessagesUpdateStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesUpdateStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * آپدیت وضعیت فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUpdateStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUpdateStatusPost(params: VoiceMessagesUpdateStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesUpdateStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesDeleteGet()` */
  static readonly VoiceMessagesDeleteGetPath = '/VoiceMessages/Delete';

  /**
   * بررسی دسترسی حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesDeleteGet$Response(params?: VoiceMessagesDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return voiceMessagesDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesDeleteGet(params?: VoiceMessagesDeleteGet$Params, context?: HttpContext): Observable<Blob> {
    return this.voiceMessagesDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `voiceMessagesDeleteDelete()` */
  static readonly VoiceMessagesDeleteDeletePath = '/VoiceMessages/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesDeleteDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesDeleteDelete$Response(params: VoiceMessagesDeleteDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesDeleteDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesDeleteDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesDeleteDelete(params: VoiceMessagesDeleteDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesDeleteDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesDeleteVoiceMessagesByIdsGet()` */
  static readonly VoiceMessagesDeleteVoiceMessagesByIdsGetPath = '/VoiceMessages/DeleteVoiceMessagesByIds';

  /**
   * بررسی دسترسی حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesDeleteVoiceMessagesByIdsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesDeleteVoiceMessagesByIdsGet$Response(params?: VoiceMessagesDeleteVoiceMessagesByIdsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return voiceMessagesDeleteVoiceMessagesByIdsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesDeleteVoiceMessagesByIdsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesDeleteVoiceMessagesByIdsGet(params?: VoiceMessagesDeleteVoiceMessagesByIdsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.voiceMessagesDeleteVoiceMessagesByIdsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `voiceMessagesDeleteVoiceMessagesByIdsDelete()` */
  static readonly VoiceMessagesDeleteVoiceMessagesByIdsDeletePath = '/VoiceMessages/DeleteVoiceMessagesByIds';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesDeleteVoiceMessagesByIdsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesDeleteVoiceMessagesByIdsDelete$Response(params: VoiceMessagesDeleteVoiceMessagesByIdsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesDeleteVoiceMessagesByIdsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesDeleteVoiceMessagesByIdsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesDeleteVoiceMessagesByIdsDelete(params: VoiceMessagesDeleteVoiceMessagesByIdsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesDeleteVoiceMessagesByIdsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetVoiceMessageWithPagination()` */
  static readonly VoiceMessagesGetVoiceMessageWithPaginationPath = '/VoiceMessages/GetVoiceMessageWithPagination';

  /**
   * دریافت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetVoiceMessageWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetVoiceMessageWithPagination$Response(params: VoiceMessagesGetVoiceMessageWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetVoiceMessagesWithPaginationDto>> {
    return voiceMessagesGetVoiceMessageWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetVoiceMessageWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetVoiceMessageWithPagination(params: VoiceMessagesGetVoiceMessageWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetVoiceMessagesWithPaginationDto> {
    return this.voiceMessagesGetVoiceMessageWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetVoiceMessagesWithPaginationDto>): CustomResultOfPaginatedListOfGetVoiceMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetVoiceMessageAuditWithPagination()` */
  static readonly VoiceMessagesGetVoiceMessageAuditWithPaginationPath = '/VoiceMessages/GetVoiceMessageAuditWithPagination';

  /**
   * دریافت لاگ آدیت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetVoiceMessageAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetVoiceMessageAuditWithPagination$Response(params: VoiceMessagesGetVoiceMessageAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return voiceMessagesGetVoiceMessageAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لاگ آدیت بر اساس صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetVoiceMessageAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetVoiceMessageAuditWithPagination(params: VoiceMessagesGetVoiceMessageAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.voiceMessagesGetVoiceMessageAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUploadVocalistFile()` */
  static readonly VoiceMessagesUploadVocalistFilePath = '/VoiceMessages/UploadVocalistFile';

  /**
   * دریافت آدرس فایل با آواخوان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUploadVocalistFile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUploadVocalistFile$Response(params: VoiceMessagesUploadVocalistFile$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUploadVocalistResult>> {
    return voiceMessagesUploadVocalistFile(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آدرس فایل با آواخوان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUploadVocalistFile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUploadVocalistFile(params: VoiceMessagesUploadVocalistFile$Params, context?: HttpContext): Observable<CustomResultOfUploadVocalistResult> {
    return this.voiceMessagesUploadVocalistFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUploadVocalistResult>): CustomResultOfUploadVocalistResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetVoiceMessagesList()` */
  static readonly VoiceMessagesGetVoiceMessagesListPath = '/VoiceMessages/GetVoiceMessagesList';

  /**
   * دریافت لیست اصوات تایید شده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetVoiceMessagesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetVoiceMessagesList$Response(params?: VoiceMessagesGetVoiceMessagesList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetVoiceMessagesListDto>> {
    return voiceMessagesGetVoiceMessagesList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست اصوات تایید شده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetVoiceMessagesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetVoiceMessagesList(params?: VoiceMessagesGetVoiceMessagesList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetVoiceMessagesListDto> {
    return this.voiceMessagesGetVoiceMessagesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetVoiceMessagesListDto>): CustomResultOfListOfGetVoiceMessagesListDto => r.body)
    );
  }

  /** Path part for operation `voiceMessagesCreateVoiceMessageByVocalist()` */
  static readonly VoiceMessagesCreateVoiceMessageByVocalistPath = '/VoiceMessages/CreateVoiceMessageByVocalist';

  /**
   * ایجاد صوت بر اساس آواخوان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesCreateVoiceMessageByVocalist()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesCreateVoiceMessageByVocalist$Response(params: VoiceMessagesCreateVoiceMessageByVocalist$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesCreateVoiceMessageByVocalist(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد صوت بر اساس آواخوان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesCreateVoiceMessageByVocalist$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesCreateVoiceMessageByVocalist(params: VoiceMessagesCreateVoiceMessageByVocalist$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesCreateVoiceMessageByVocalist$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetNewStatusGet()` */
  static readonly VoiceMessagesGetNewStatusGetPath = '/VoiceMessages/GetNewStatus';

  /**
   * بررسی دسترسی دریافت آخرین وضعیت صدا.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetNewStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetNewStatusGet$Response(params?: VoiceMessagesGetNewStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return voiceMessagesGetNewStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی دریافت آخرین وضعیت صدا.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetNewStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetNewStatusGet(params?: VoiceMessagesGetNewStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.voiceMessagesGetNewStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetNewStatusPost()` */
  static readonly VoiceMessagesGetNewStatusPostPath = '/VoiceMessages/GetNewStatus';

  /**
   * دریافت آخرین وضعیت صدا.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetNewStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetNewStatusPost$Response(params: VoiceMessagesGetNewStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesGetNewStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین وضعیت صدا.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetNewStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesGetNewStatusPost(params: VoiceMessagesGetNewStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesGetNewStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesUpdateVoiceMessageGroup()` */
  static readonly VoiceMessagesUpdateVoiceMessageGroupPath = '/VoiceMessages/UpdateVoiceMessageGroup';

  /**
   * ویرایش گروه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesUpdateVoiceMessageGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUpdateVoiceMessageGroup$Response(params: VoiceMessagesUpdateVoiceMessageGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return voiceMessagesUpdateVoiceMessageGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش گروه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesUpdateVoiceMessageGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  voiceMessagesUpdateVoiceMessageGroup(params: VoiceMessagesUpdateVoiceMessageGroup$Params, context?: HttpContext): Observable<CustomResult> {
    return this.voiceMessagesUpdateVoiceMessageGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `voiceMessagesGetVoicesByVoiceMessageGroup()` */
  static readonly VoiceMessagesGetVoicesByVoiceMessageGroupPath = '/VoiceMessages/GetVoicesByVoiceMessageGroup';

  /**
   * ویرایش گروه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voiceMessagesGetVoicesByVoiceMessageGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetVoicesByVoiceMessageGroup$Response(params?: VoiceMessagesGetVoicesByVoiceMessageGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetVoicesByVoiceMessageGroupDto>> {
    return voiceMessagesGetVoicesByVoiceMessageGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش گروه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voiceMessagesGetVoicesByVoiceMessageGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voiceMessagesGetVoicesByVoiceMessageGroup(params?: VoiceMessagesGetVoicesByVoiceMessageGroup$Params, context?: HttpContext): Observable<CustomResultOfListOfGetVoicesByVoiceMessageGroupDto> {
    return this.voiceMessagesGetVoicesByVoiceMessageGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetVoicesByVoiceMessageGroupDto>): CustomResultOfListOfGetVoicesByVoiceMessageGroupDto => r.body)
    );
  }

}
